export const userColumns = [
 
    {
      field: "wardCode",
      headerName: "Ward Code",
      width: 200,
    },
    {
      field: "wardName",
      headerName: "Ward Name",
      width: 150,
    },
    {
      field: "activeStatus",
      headerName: "Active Status",
      width: 150,
    },
    {
        field: "description",
        headerName: "Description",
        width: 150,
      },
   
  ];